import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { PreviousReportsList } from './PreviousReportsList';
export const PreviousReportsPane = (props) => {
    const { patientId } = props;
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => setIsOpen((prev) => !prev);
    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };
        document.body.addEventListener('keydown', onKeyDown);
        return () => {
            document.body.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx('fixed z-10 inset-0 bg-black transition-opacity duration-200', {
                'opacity-70 pointer-events-auto': isOpen,
                'opacity-0 pointer-events-none': !isOpen,
            }), onClick: () => setIsOpen(false) }),
        React.createElement("div", { className: clsx('absolute z-20 right-0 top-0 bottom-0 transition-transform bg-white', {
                ' translate-x-full': !isOpen,
                'translate-x-0': isOpen,
            }) },
            React.createElement("button", { type: "button", className: "bg-app-mui-blue py-5 pr-3 pl-5 flex items-center justify-center text-white absolute right-full top-5 rounded-l-lg focus:outline-none focus:ring-2", onClick: handleOpen },
                React.createElement(FaChevronLeft, { className: clsx('w-4 h-5 mr-2', { 'rotate-180': isOpen }) }),
                React.createElement("span", { className: "flex-shrink text-xs leading-tight uppercase font-bold" }, "Previous Reports")),
            isOpen && React.createElement("div", { className: "pt-5 pr-5 pl-4 border-l-4 border-app-blue-green-light h-full overflow-auto" },
                React.createElement(PreviousReportsList, { patientId: patientId, enabled: isOpen })))));
};
